import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { CircularProgress } from "@mui/material";
import React from "react";
import useNotify from "./useNotify";
const DownloadFieldByPdfLink = ({ ...props }) => {
  const { linktoken, filename, sx } = props;
  const reqUrl = `${import.meta.env.VITE_API_URL}/pdfs/` + linktoken;
  const { success, warning, error, info } = useNotify();
  const [loading, setLoading] = React.useState(false);
  const handDownload = async (docFileName: string, reqUrl: string) => {
    setLoading(true);
    try {
      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");

      const response = await fetch(`${reqUrl}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "X-CSRF-TOKEN": csrfToken ?? "",
          "X-XSRF-TOKEN": csrfToken ?? "",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        error("Network response was not ok, File not found");
        return;
      }
      const blobbody = await response.blob();
      if (blobbody.size === 0) {
        error("File not found");
        return;
      }

      const url = window.URL.createObjectURL(blobbody);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", docFileName);
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading attachment:", error);
    }
    setLoading(false);
  };

  return loading ? (
    // loading icon
    <CircularProgress
      sx={{ color: "#1976d2" }}
      size="16px"
      title="Downloading..."
    />
  ) : (
    <InsertDriveFileIcon
      onClick={() => handDownload(filename, reqUrl)}
      sx={{ color: "#1976d2", cursor: "pointer", ...sx }}
    />
  );
};
export default DownloadFieldByPdfLink;
